import { elements } from '../periodicElements';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { handleElementClick, renderElementVideo, renderColumn } from '../FunctionsElements';
import { useTranslation } from 'react-i18next';

export default function MolecularDesign() {
  const [selectedElement, setSelectedElement] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {selectedElement ? (
        /* Visualização do Elemento Selecionado (Ex: Design Molecular) */
        <section className="bg-background-secondary min-h-screen flex flex-col items-center justify-center p-4 transition-colors duration-300">
          <div className="flex flex-col items-center w-full max-w-4xl">
            {renderElementVideo(selectedElement, setSelectedElement, t, navigate)}
          </div>
        </section>
      ) : (
        /* Visualização da Grade de Elementos */
        <section className="mx-auto min-h-screen p-3 pt-20 md:pt-24 bg-background-secondary transition-colors duration-300">
          <div className="flex flex-col items-center px-4">

            <div className="w-full max-w-4xl mb-6">
              <Link to="/TPQVS">
                <button className="btn-primary inline-flex items-center px-5 py-2.5 text-sm md:text-base">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  {t("elements.back")}
                </button>
              </Link>
            </div>

            <div className="flex flex-col md:flex-row justify-center items-center md:items-start gap-8 w-full max-w-6xl">
              {/* Coluna de Elementos (25 a 29) */}
              <div className="grid grid-cols-2 text-center gap-2">
                {renderColumn(elements, 25, 29, false, 0, handleElementClick, setSelectedElement, true)} 
              </div>

              {/* Card de Texto Informativo */}
              <div className="w-full p-6 sm:w-1/2 lg:w-2/4 bg-surface border border-border-light rounded-lg shadow-lg text-text-primary mt-4 xl:mt-14 transition-colors duration-300">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center mb-4 border-b-2 border-primary text-text-primary pb-2">
                  {t("MolecularDesign.title")} 
                </h2>
                <p className="text-xs sm:text-sm md:text-base leading-relaxed text-justify text-text-secondary">
                  {t("MolecularDesign.discretion")} 
                </p>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}